/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.unspecced.getConfig'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  checkEmailConfirmed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  liveNow: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LiveNowConfig>((() => liveNowConfig) as any),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get miscellaneous runtime configuration. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type LiveNowConfig = {
  $type?: 'app.bsky.unspecced.getConfig#liveNowConfig'
  did: l.DidString
  domains: string[]
}

export type { LiveNowConfig }

const liveNowConfig = /*#__PURE__*/ l.typedObject<LiveNowConfig>(
  $nsid,
  'liveNowConfig',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    domains: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  }),
)

export { liveNowConfig }
